<wl-questionnaire-question-single
  [questionData]="questionData()"
  [showPrevious]="hasPreviousQuestion()"
  (submitAnswer)="submitAnswer($event)"
  (back)="goToPreviousQuestion()"
  (requestInfo)="requestInfo($event)"
/>
